<template lang="pug">
  v-row(no-gutters) 
    v-col(  
      v-for="(item,i) in items"
      :key="i"
      cols=12
    )
      v-card( 
        flat 
      ).mx-2.mb-2.hiddenmobile
        v-card-text( 
          @click="$emit('click:row',item)"
        )
          v-row( 
            v-for="(header,ih) in newHeaders"
            :key="ih"
            v-show="!header.IsHideCard"
            no-gutters
            align="center"
          )
            v-col(
              cols="6" 
            ).black--text  {{ header.text }}
            v-col(
              cols="6" 
              align="end"
            )
              b.black--text  
                slot(
                  :name="manageName(header)"
                  v-bind:item="item" 
                  v-bind:value="item[header.value]" 
                )
                  | {{ manageVar(header,item) || '-' }} 
        v-divider    
        v-row(
          no-gutters
          align="center"
        ).pa-3
          v-col( 
            align="start" 
          ).card-mobile
            slot(
              name="item.leftActionEffectToCard" 
              v-bind:item="item"
            ) 
          v-col( 
            align="center" 
          ).card-mobile
            slot(
              name="item.centerActionEffectToCard"
              v-bind:item="item"
            )
          v-col( 
            align="end" 
          ).card-mobile.black--text
            slot(
              name="item.rightActionEffectToCard"
              v-bind:item="item" 
            )  
</template>
<script>
export default {
  props : {
    items : {
      type : Array,
      default : ()=>[]
    },
    headers : {
      type : Array,
      default : ()=>[]
    }
  }, 
  computed:{ 
    newHeaders () {
      return this.headers.filter(x=>!this.expandSlot.includes(x.value))
    },
    expandSlot () {
      return [
        'leftActionEffectToCard',
        'centerActionEffectToCard',
        'rightActionEffectToCard'
      ]
    }
  },
  methods: {
    // Not Remove eslint-disable line it'll effect for eval function****
    // eslint-disable-next-line no-unused-vars
    manageVar (header,item) {
      //item had used on eval func
      let string = "item." + (header || {}).value
      return eval(string)
    },
    manageName (item) {
      return "item." + (item || {}).value
    }
  }
}
</script>
<style scoped>  
.card-mobile {
  font-size: 12px !important; 
  color: #bdbdbd !important;
} 
</style>